import React, { useCallback, useRef, useState } from 'react';
import { Observable } from 'rxjs';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { loadingFragments } from '../../../../store/global-slice';
import Spinner from '../../../../components/common/spinner';
import {
  ButtonComponent,
  ButtonStyling,
} from '../../../../components/form/elements/button';
import useRemove from './use-remove';

interface Props {
  id: string;
  onRemove: (id: string) => Observable<any>;
  content?: string;
  label?: string;
  prefix?: string;
}

export default function RemoveBtnComponent({
  id,
  onRemove,
  content = 'pages.crop.vaad_liz_reports_v2.remove_modal.remove',
  label = 'pages.crop.vaad_liz_reports_v2.list.remove',
  prefix = 'remove-btn',
}: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isRemoving, setIsRemoving] = useState(false);
  const { modal, confirmRemove } = useRemove(content);
  const name = useRef(`${prefix}-${id}`);

  const remove = useCallback(() => {
    setIsRemoving(true);
    dispatch(loadingFragments({ [name.current]: true }));

    confirmRemove(id, onRemove, () => {
      setIsRemoving(false);
      dispatch(loadingFragments({ [name.current]: false }));
    });
  }, [confirmRemove, dispatch, id, onRemove]);

  return (
    <>
      {isRemoving ? (
        <Spinner visible size="sm" />
      ) : (
        <ButtonComponent
          name={name.current}
          label={t(label)}
          click={remove}
          buttonLoadingFragment={name.current}
          styling={ButtonStyling.cancel}
          disabled={isRemoving}
        />
      )}

      {modal}
    </>
  );
}
